// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"P7-z","button":"Q7-z","disabled":"R7-z","creditCard":"S7-z","wrapper":"T7-z"};